import http, { apiUrl, publicUrl } from './http'
import auth from './auth'
import user from './user'
import pusher from './pusher'
import notify from './notify'
import queryString from './qs'

export {
  http,
  apiUrl,
  publicUrl,
  auth,
  user,
  pusher,
  notify,
  queryString
}

export const DEFAULT_REDIRECT = {
  admin: { name: 'dashboard' },
  user: { name: 'dashboard' }
}
